<tt-page *ngIf="page" class="col-xs-12 sp-0">
    <tt-card ttHeading="serialno">
        <tt-input *ngFor="let line of page" [ttLabel]="line.prod_name" [ttTranslateLabel]="false" [(ttModel)]="line.serialno" [ttDisabled]="saving"></tt-input>
        <tt-button-save ttText="save" (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="loading"></tt-button-save>
    </tt-card>
</tt-page>
